import { GlobalAxios } from "../axios/axios-config";
import { IPatientEncounterComplaintPage } from "../models/patient-encounter-complaint";

const PATIENT_ENCOUNTER_COMPLAINT_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/PatientEncounterComplaint";

export const patientEncounterComplaintList = (params?: any) => {
  return GlobalAxios.get<IPatientEncounterComplaintPage>(
    PATIENT_ENCOUNTER_COMPLAINT_ROUTE,
    { params },
  );
};
